import React, { useState, useRef } from 'react';
import emailjs from 'emailjs-com';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: 'General Inquiry',
    message: '',
    location: '',
    date: '',
    activity: ''
  });

  const [showInvestigationFields, setShowInvestigationFields] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const form = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    if (name === 'subject' && value === 'Book Investigation') {
      setShowInvestigationFields(true);
    } else if (name === 'subject' && value !== 'Book Investigation') {
      setShowInvestigationFields(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    
    // Check if this is an investigation booking
    const isInvestigationBooking = formData.subject === 'Book Investigation';
    
    // Format the form data with simpler variable names
    const templateParams = {
      name: formData.name || "No Name Provided",
      email: formData.email || "No Email Provided",
      phone: formData.phone || "No Phone Provided",
      subject: formData.subject || "No Subject",
      message: formData.message || "No Message",
      location: isInvestigationBooking ? (formData.location || "Not specified") : "N/A - Not an investigation request",
      date: isInvestigationBooking ? (formData.date || "Not specified") : "N/A - Not an investigation request",
      activity: isInvestigationBooking ? (formData.activity || "Not specified") : "N/A - Not an investigation request"
    };

    console.log('Sending email with params:', templateParams);

    // Send the email using EmailJS
    emailjs.send(
      'service_f1u7gxm', 
      'template_q0j89d2', 
      templateParams,
      'WkSf8SnShahxDs9ms'
    )
    .then((result) => {
      console.log('Email sent successfully:', result);
      setIsSubmitting(false);
      setSubmitStatus('success');
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: 'General Inquiry',
        message: '',
        location: '',
        date: '',
        activity: ''
      });
      setShowInvestigationFields(false);
    })
    .catch((error) => {
      console.error('Failed to send email:', error);
      setIsSubmitting(false);
      setSubmitStatus('error');
    });
  };

  return (
    <div className="contact">
      <div className="contact-header">
        <h1>Contact Us</h1>
        <p>Reach out to Black Cat Paranormal team</p>
      </div>

      <div className="contact-container">
        <div className="contact-info">
          <h2>Get In Touch</h2>
          <p>Have questions about our services or want to book an investigation? Fill out the form or contact us directly using the information below.</p>
          
          <div className="info-item">
            <i className="fas fa-envelope"></i>
            <p>the.blackcat.paranormal@gmail.com</p>
          </div>
          
          <div className="info-item">
            <i className="fas fa-phone"></i>
            <p>(555) 123-4567</p>
          </div>
          
          <div className="info-item">
            <i className="fas fa-map-marker-alt"></i>
            <p>123 Haunted Lane, Spookytown, ST 12345</p>
          </div>
          
          <div className="business-hours">
            <h3>Business Hours</h3>
            <p>Monday - Friday: 10:00 AM - 6:00 PM</p>
            <p>Saturday: 12:00 PM - 4:00 PM</p>
            <p>Sunday: Closed</p>
            <p><em>Investigations are scheduled based on availability and can occur outside of business hours.</em></p>
          </div>
          
          <div className="social-links">
            <h3>Follow Us</h3>
            <div className="social-icons">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.youtube.com/@Bc.Paranormal" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="https://www.tiktok.com/@blackcat_paranormal" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-tiktok"></i>
              </a>
            </div>
          </div>
        </div>
        
        <div className="contact-form">
          <h2>Send Us a Message</h2>
          {submitStatus === 'success' && (
            <div className="success-message">
              Thank you for your message! We will get back to you soon.
            </div>
          )}
          {submitStatus === 'error' && (
            <div className="error-message">
              Sorry, there was a problem sending your message. Please try again or contact us directly.
            </div>
          )}
          <form ref={form} onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <select
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              >
                <option value="General Inquiry">General Inquiry</option>
                <option value="Book Investigation">Book Investigation</option>
                <option value="Equipment Question">Equipment Question</option>
                <option value="Merchandise Question">Merchandise Question</option>
                <option value="Other">Other</option>
              </select>
            </div>
            
            {showInvestigationFields && (
              <>
                <div className="form-group">
                  <label htmlFor="location">Location to Investigate</label>
                  <input
                    type="text"
                    id="location"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="date">Preferred Date</label>
                  <input
                    type="date"
                    id="date"
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="activity">Paranormal Activity Experienced</label>
                  <textarea
                    id="activity"
                    name="activity"
                    value={formData.activity}
                    onChange={handleChange}
                    rows="3"
                  ></textarea>
                </div>
              </>
            )}
            
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="5"
                required
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className="submit-btn" 
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>

      <div className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-container">
          <div className="faq-item">
            <h3>How much does an investigation cost?</h3>
            <p>Investigation costs vary depending on location, duration, and equipment needed. Basic investigations start at $300. Contact us for a personalized quote.</p>
          </div>
          <div className="faq-item">
            <h3>How long does an investigation take?</h3>
            <p>Most investigations last 4-8 hours, typically during evening hours when paranormal activity tends to be higher. Complex cases may require multiple visits.</p>
          </div>
          <div className="faq-item">
            <h3>What areas do you serve?</h3>
            <p>We primarily serve within a 100-mile radius of Spookytown. For locations outside this area, additional travel fees may apply.</p>
          </div>
          <div className="faq-item">
            <h3>Do I need to be present during the investigation?</h3>
            <p>It's recommended but not required. Having the property owner present can be helpful, but we understand if you prefer not to participate.</p>
          </div>
          <div className="faq-item">
            <h3>How soon will I receive results?</h3>
            <p>We typically provide preliminary findings within 48 hours. A complete analysis with all evidence and documentation is delivered within 2 weeks.</p>
          </div>
          <div className="faq-item">
            <h3>Can you remove spirits from my property?</h3>
            <p>We offer cleansing services, but we focus primarily on investigation and documentation. If a cleansing is needed, we can refer you to trusted specialists.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
